module.exports = __webpack_public_path__ + "97410fbd895d11605296d4bec32a8413.jpg";